import {User} from 'src/openapi/models/User';
import {UserRoles} from 'src/openapi/models/UserRoles';

export const filterUsers = (
    users: User[],
    userRolesData: UserRoles[],
): User[] => {
    const existingEmails = new Set(userRolesData.map(userRoles => userRoles.email));

    return users.filter(user => !existingEmails.has(user.email));
};
